module.exports = __webpack_public_path__ + "img/1_1.96920dba.jpg";